<div class="row mb-4">
  <div class="col">
    <span>{{ data.message }}</span>
  </div>
</div>
<div class="d-flex">
  <div class="flex-fill"></div>
  <button mat-raised-button color="primary" (click)="ok()" class="me-2">{{ data.primaryButtonLabel }}</button>
  <button mat-raised-button (click)="cancel()">{{ data.secondaryButtonLabel }}</button>
</div>
